import styled from 'styled-components';

import { Container as FormInputContainer } from '../Form/FormInput';
import { Modal } from '../Modal/Modal';

export const ExtraOptions = styled.div`
  display: flex;
  justify-content: space-between;
  font: var(--fontStyleFootnote);
  color: var(--dialogParagraphForeground);

  & ${FormInputContainer} {
    margin: 0;
  }
`;

ExtraOptions.displayName = 'ExtraOptions';

export const RegistrationSection = styled.div`
  margin: 1.5rem 0 0.5rem;
  font: var(--fontStyleBody);
  color: var(--dialogParagraphForeground);
`;

RegistrationSection.displayName = 'RegistrationSection';

export const SpinnerContainer = styled.div`
  text-align: center;
  margin: 2rem 1rem 4rem;
`;

export const LoginModal = styled(Modal)`
  width: 100%;
  max-width: 25rem;
  background-color: var(--pageSecondaryBackground);
  text-align: center;
`;
